import React from "react";
import { createSearchParams, useNavigate } from "react-router-dom";

const CatCard = ({ info}) => {
  const navigate = useNavigate();
  const gotocat = newtype => {
    
     navigate({
       pathname: "/categories",
       search: createSearchParams({
         type: newtype
       }).toString()
     });
  };
  return (
    <div className="SpecialTipCard rounded-[20px] CatCard" onClick={()=>gotocat(info.title)}>
      {/* <div
        className="SpecialTipCard__img  w-[309px] h-[386px] "
        style={{ backgroundImage: `url(${img})` }}
      /> */}
      <img src={info.image.path} className='w-[259px] h-[324px] '/>
      <div className="white-bg  SpecialTipCard__sub CatCard__sub">
        <div className="text-[20px] text-[#292D32] my-[5px]">
          {info.title}
        </div>
        <div className="text-[16px] text-[#797D82] ">
        {info.residences_count} اقامتگاه
        </div>
      </div>
    </div>
  );
};

export default CatCard;
